import React, { useEffect, useMemo, useRef, useState } from "react";

import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import CloseIcon from "@mui/icons-material/Close";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import { Box, CircularProgress, Stack, Switch } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { ButtonVariant } from "Constant/button";
import { routes } from "Constant/routes";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import "react-json-view-lite/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";

import { addDestinationToTracker } from "helpers/destinations/createDestination";
import getDestinationIcon from "helpers/destinations/getDestinationIcon";
import { getSourceDocumentLink } from "helpers/documentation/getDocumentationLinks";
import { addSourceToTracker } from "helpers/Sources/createSource";
import getSourceIcon from "helpers/Sources/getSourceIcon";
import { sendFormToService } from "helpers/trackers/createTracker";
import { getDestinationStatus } from "helpers/trackers/getDestinationStatus";

import CopyIconButton from "components/atoms/CopyIconButton";
import StandartButton from "components/atoms/StandartButton";
import BusinessSelect from "components/BusinessSelect";
import DestinationTableContainerOld from "components/DestinationTableContainerOld";
import EventMappingBox from "components/EventMappingBox";
import { ModalName } from "components/organisms/ModalRoot/ModalRoot.layout";
import SourceTableContainerOld from "components/SourceTableContainerOld";
import SwalAlertComp from "components/SwalAlert";
import InlineTrackerNameEdit from "components/TrackerNameEdit/InlineTrackerNameEdit";
import TrackerNotes from "components/TrackerNotes/TrackerNotes";

import PageContainer from "../../components/atoms/PageContainer";
import { getDestinationForAddingTrackers } from "../../redux/slices/destinations/destinations.asyncActions";
import { openModal } from "../../redux/slices/modal/modal.slice";
import { getSourceForAddingTrackers } from "../../redux/slices/sources/sources.asyncActions";
import {
    getExcistTrackersRedux,
    getSingleTrackerRedux,
} from "../../redux/slices/trackers/trackers.asyncActions";
import { hydrateSingleTrackerFromCache } from "../../redux/slices/trackers/trackers.slice";
import FlowDiagram from "../Home/FlowDiagram";
import { LogoIcon } from "../shared/CardStyles";
import "./singleTracker.css";
import DestinationModal from "./TrackerDetails/DestinationModal/DestinationModal";
import { getDestinationTabs } from "./TrackerDetails/DestinationModal/DestinationModal.config";
import { SourceModal } from "./TrackerDetails/SourceModal/exports";
import SendInstructionsModal from "./TrackerDetails/SourceModal/SendInstructionsModal";
import { getSourceTabs } from "./TrackerDetails/SourceModal/SourceModal.config";

const SourceErrorTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#000000",
        color: "#000",
        maxWidth: 220,
        fontSize: "12px",
        borderRadius: "10px",
        fontFamily: '"Nunito", serif',
        padding: "15px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    },
    [`& .${tooltipClasses.tooltip} p`]: {
        fontWeight: "bold",
        fontFamily: '"Nunito", serif',
        color: "white",
        fontSize: "14px",
    },
    [`& .${tooltipClasses.tooltip} span`]: {
        fontWeight: "300",
        fontFamily: '"Nunito", serif',
        color: "white",
        fontSize: "12px",
    },
}));

const DestinationErrorTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#000000",
        color: "#000",
        maxWidth: 220,
        fontSize: "12px",
        borderRadius: "10px",
        fontFamily: '"Nunito", serif',
        padding: "15px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    },
    [`& .${tooltipClasses.tooltip} p`]: {
        fontWeight: "bold",
        fontFamily: '"Nunito", serif',
        color: "white",
        fontSize: "14px",
    },
    [`& .${tooltipClasses.tooltip} span`]: {
        fontWeight: "300",
        fontFamily: '"Nunito", serif',
        color: "white",
        fontSize: "12px",
    },
}));

const DocumentCard = ({ icon, title, children, className }) => (
    <Card
        className={className}
        sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "10px",
            border: "1px solid rgba(0,0,0,0.05)",
            boxShadow: "none",
            height: "100%",
        }}
    >
        <CardContent sx={{ position: "relative" }}>
            <Typography
                sx={{
                    fontSize: 18,
                    fontWeight: 700,
                    fontFamily: "Nunito, sans-serif",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                }}
            >
                {icon}
                {title}
            </Typography>
            {children}
        </CardContent>
    </Card>
);

const SingleTracker = () => {
    const [showMailModal, setShowMailModal] = useState(false);
    const [selectedDestination, setSelectedDestination] = useState("");
    const [selectedItems, setSelectedItems] = useState({});
    const [isAddingDestination, setIsAddingDestination] = useState(false);

    const [selecetableModalState, setSelecetableModalState] = useState(false);
    const [selecetableModalStateSource, setSelecetableModalStateSource] =
        useState(false);
    const dispatch = useDispatch();
    const [guideText, setGuideText] = useState("");
    const params = useParams();
    const [documentDetailStatus, setDocumentDetailStatus] = useState(false);
    const [sourceModalOpen, setSourceModalOpen] = useState(false);
    const [sourceModalItem, setSourceModalItem] = useState({});
    const [sourceModalInitialTab, setSourceModalInitialTab] = useState(null);
    const [
        isAddExistDestinationModalLoading,
        setIsAddExistDestinationModalLoading,
    ] = useState(false);
    const [isAddExistSourceModalLoading, setIsAddExistSourceModalLoading] =
        useState(false);

    const language = useSelector((state) => state.languagesState.languages);
    const tracker = useSelector(
        (state) => state.allTrackersState.singleTracker,
    );
    const trackerResponseMessage = useSelector(
        (state) => state.allTrackersState.singleTrackerResponseMessage,
    );
    const trackerStatus = useSelector(
        (state) => state.allTrackersState.singleTrackerStatus,
    );
    const activeTrackerId = useSelector(
        (state) => state.allTrackersState.activeTrackerId,
    );
    const existSources = useSelector(
        (state) => state.allSourcesState.getAllSources.sourcesForAddingTracker,
    );

    // Get sources types for filtering destinations
    const sourcesTypes = useSelector(
        (state) => state.allSourcesTypesState.sources,
    );

    const availableDestinations = useMemo(() => {
        if (tracker.tracker?.sources?.length === 0)
            return sourcesTypes
                ?.map((source) => source?.destinations)
                ?.flat()
                ?.map((destination) => destination.code)
                ?.filter(
                    (destination, index, self) =>
                        self.indexOf(destination) === index,
                );
        if (!tracker?.tracker?.sources || !sourcesTypes) return [];

        return sourcesTypes
            ?.filter((source) =>
                tracker.tracker.sources?.find(
                    (selectedSource) =>
                        selectedSource.source_type?.code === source.code,
                ),
            )
            ?.map((source) => source?.destinations)
            ?.flat()
            ?.map((destination) => destination.code)
            ?.filter(
                (destination, index, self) =>
                    self.indexOf(destination) === index,
            );
    }, [sourcesTypes, tracker?.tracker?.sources]);

    const location = useLocation();
    const navigate = useNavigate();

    const existSourcesStatus = useSelector(
        (state) =>
            state.allSourcesState.getAllSources.statusforAddingTrackersSource,
    );
    const existDestinations = useSelector(
        (state) =>
            state.allDestinationsState.getAllDestinations
                .destinationsForAddingTracker,
    );
    const existDestinationsStatus = useSelector(
        (state) =>
            state.allDestinationsState.getAllDestinations
                .statusforAddingTrackers,
    );

    const isFromWizardCaseHandled = useRef(null);
    useEffect(() => {
        const trackerId = tracker?.tracker?.id;
        const isSameTracker = trackerId && trackerId.toString() === params.id;
        if (
            !isSameTracker ||
            !location.state?.fromWizard ||
            isFromWizardCaseHandled.current === trackerId
        ) {
            return;
        }

        const sourceToBeOpened = tracker?.tracker?.sources?.find((source) =>
            [
                "js",
                "capi",
                "androidcapi",
                "ioscapi",
                "appsflyer",
                "adjust",
            ].includes(source?.source_type?.code),
        );
        if (sourceToBeOpened) {
            setSourceModalOpen(true);
            setSourceModalItem(sourceToBeOpened);
            isFromWizardCaseHandled.current = trackerId;
        }
    }, [tracker, location.state?.fromWizard, params.id]);
    useEffect(() => {
        setGuideText(
            language?.tracker_detail
                ?.frontend_code_modification_guide_right_text ??
                "This guide provides you with step-by-step instructions to successfully complete the SignalSight CAPI implementation on your website. To update your website code, you can either use Google Tag Manager or modify it directly. If you have any questions, feel free to contact our team at help@signalsight.io — we're always happy to help.",
        );
    }, [language]);

    useEffect(() => {
        if (!params.id) {
            return undefined;
        }
        // Stale-while-revalidate: show the cached tracker (if any) right away,
        // then always refetch. Abort the in-flight request when the id changes
        // or the page unmounts so a late response can't overwrite the store
        // with another tracker's data.
        dispatch(hydrateSingleTrackerFromCache(params.id));
        const request = dispatch(getSingleTrackerRedux(params.id));
        return () => request.abort();
    }, [params.id]);

    // With cached data the tracker object changes twice per visit (cache, then
    // fresh). Only show the notice once per tracker id.
    const pixelNoticeShownForTrackerId = useRef(null);
    useEffect(() => {
        const trackerId = tracker?.tracker?.id;
        if (
            trackerId &&
            pixelNoticeShownForTrackerId.current !== trackerId &&
            tracker?.tracker?.is_crm === false &&
            tracker?.tracker?.is_consolidated_container === false
        ) {
            pixelNoticeShownForTrackerId.current = trackerId;
            const metaConversionsApiDestination =
                tracker?.tracker?.destinations?.find(
                    (destination) =>
                        destination?.destination_type?.name ===
                        "Meta Conversions Api",
                );
            const pixelId = metaConversionsApiDestination
                ? metaConversionsApiDestination.pixel_id
                : "";
            Swal.fire({
                title: "Pixel Type Notice",
                icon: "warning",
                html:
                    '<p style="text-align:start">Please convert it to CRM pixel by following these instructions:</p>' +
                    '<ol style="text-align: start; list-style: auto; padding-left: 20px; display: flex; flex-direction: column; gap: 5px;">' +
                    '<li><a href="https://www.facebook.com/events_manager2/" style="color: #5353ec" target="_blank">Go to Events Manager</a></li>' +
                    "<li>Click the green Plus icon or Connect Data Sources from the menu.</li>" +
                    "<li>A Connect a New Data Source pop-up window will appear. Select CRM and click Connect.</li>" +
                    "<li>A Connect your CRM for conversion leads pop-up window will appear. Read the instructions and benefits from conversion leads and then click Next.</li>" +
                    "<li>Select the Meta Pixel with id <span>" +
                    `${pixelId}` +
                    "</span> and click Continue.</li>" +
                    "</ol>",
            });
        }
    }, [tracker]);

    useEffect(() => {
        dispatch(getExcistTrackersRedux());
    }, [dispatch]);
    const handleShowMailModal = () => setShowMailModal(true);
    const handleMailModalClose = () => {
        setShowMailModal(false);
    };

    const handleSendInstructions = async (payload) => {
        const result = await sendFormToService(payload);

        if (result.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: result.message && result.message,
                icon: "success",
            });
            return result;
        }

        throw new Error(result.message || "Failed to send instructions");
    };

    const handleSelectDestModalClose = () => {
        setSelectedDestination("");
        setSelecetableModalState(false);
    };
    const handleSelectSourceModalClose = () => {
        setSelectedItems({});
        setSelecetableModalStateSource(false);
    };
    const handleOpenCreateNewButton = () => {
        setSelectedDestination("");
        handleSelectDestModalClose();
        dispatch(
            openModal({
                modalName: ModalName.CREATE_DESTINATION,
                data: {
                    tracker_id: params.id,
                },
            }),
        );
    };
    const handleOpenCreateNewButtonSource = () => {
        setSelectedItems({});
        handleSelectSourceModalClose();
        dispatch(
            openModal({
                modalName: ModalName.CREATE_SOURCE,
                data: {
                    tracker_id: params.id,
                },
            }),
        );
    };
    const handleShowDestinationModal = async () => {
        setIsAddingDestination(true);
        try {
            // Fetch both destinations and source types in parallel
            const [destinationsRes, sourcesTypesRes] = await Promise.all([
                dispatch(
                    getDestinationForAddingTrackers(params.id && params.id),
                ),
            ]);

            if (
                destinationsRes?.payload?.data &&
                destinationsRes?.payload?.data.length > 0
            ) {
                setSelecetableModalState(true);
            } else {
                handleOpenCreateNewButton();
            }
        } catch (error) {
            console.error("Error loading destinations or source types:", error);
        } finally {
            setIsAddingDestination(false);
        }
    };

    const handleShowSourceModal = async (e) => {
        e.stopPropagation();
        let res = await dispatch(
            getSourceForAddingTrackers(params.id && params.id),
        );
        if (res?.payload?.data && res?.payload?.data.length > 0) {
            setSelecetableModalStateSource(true);
        } else {
            handleOpenCreateNewButtonSource();
        }
    };

    const getExistSourcesRedux = () => {
        dispatch(getSourceForAddingTrackers(params.id && params.id));
    };

    const CheckHandlerDestination = (e, item) => {
        const value = item?.id;
        setSelectedDestination((prev) =>
            selectedDestination.length > 0 &&
            selectedDestination.includes(value)
                ? prev.filter((cur) => cur !== value)
                : [...prev, value],
        );
    };

    const handleSaveDestAdd = async () => {
        let newDestinationId = {
            destinations: selectedDestination,
        };
        setIsAddExistDestinationModalLoading(true);
        let response = await addDestinationToTracker(
            newDestinationId,
            params.id,
        );
        if (response.status) {
            handleSelectDestModalClose();
            dispatch(getSingleTrackerRedux(params.id && params.id));
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message && response.message,
                icon: "error",
            });
        }
        setIsAddExistDestinationModalLoading(false);
    };
    const handleSaveSourceAdd = async () => {
        let newSourceId = {
            sources: Object.keys(selectedItems),
        };
        setIsAddExistSourceModalLoading(true);
        let response = await addSourceToTracker(newSourceId, params.id);
        if (response.status) {
            handleSelectSourceModalClose();
            dispatch(getSingleTrackerRedux(params.id && params.id));
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message && response.message,
                icon: "error",
            });
        }
        setIsAddExistSourceModalLoading(false);
    };

    useEffect(() => {
        // Only react to the outcome of the request for this page's tracker;
        // never redirect because of a stale/dropped response for another id.
        if (!params.id || String(params.id) !== activeTrackerId) {
            return;
        }
        if (trackerResponseMessage === "Tracker not found") {
            navigate("/error-page", {
                state: {
                    errorType: "NOT_FOUND_CONTENT",
                },
            });
        }
        // Intentionally no clearState() here: the tracker detail is kept in
        // the redux cache so revisiting the page can render instantly.
    }, [trackerResponseMessage, activeTrackerId, params.id]);

    const [trackersStatusList, setTrackersStatusList] = useState([]);
    const [toggleStatusLoadingIndex, setToggleStatusLoadingIndex] =
        useState(null);

    useEffect(() => {
        if (
            tracker !== undefined &&
            tracker !== null &&
            tracker.tracker !== undefined &&
            tracker.tracker.destinations !== undefined &&
            tracker.tracker.destinations.length > 0
        ) {
            setTrackersStatusList([
                ...tracker.tracker.destinations.map(
                    (x) => x.tracker_status === 1,
                ),
            ]);
        }
    }, [tracker]);

    const handleToggleStatus = async (val, destinationId, index) => {
        const newVal = val ? 0 : 1;
        setToggleStatusLoadingIndex(index);
        try {
            await getDestinationStatus(params.id, destinationId, newVal);
            await dispatch(getSingleTrackerRedux(params.id));
            setTrackersStatusList((prev) => {
                const next = [...prev];
                next[index] = newVal === 1;
                return next;
            });
        } catch (err) {
            // Keep previous state on error; reducer may have refreshed
            setTrackersStatusList((prev) => [...prev]);
        } finally {
            setToggleStatusLoadingIndex(null);
        }
    };

    const [apiDocumentList, setApiDocumentList] = useState([]);

    useEffect(() => {
        if (tracker && tracker?.tracker && tracker?.tracker?.sources) {
            let sourceList = tracker?.tracker?.sources;
            let documentList = [];
            if (sourceList.length > 0) {
                sourceList.forEach((item) => {
                    let sourceCode = item?.source_type?.code;
                    let sourceId = item?.id;
                    if (
                        sourceCode === "ioscapi" ||
                        sourceCode === "androidcapi"
                    ) {
                        if (
                            tracker?.document_urls &&
                            tracker?.document_urls?.["app_capi.android"]
                        ) {
                            let document = tracker?.document_urls?.[
                                "app_capi.android"
                            ].find((doc) =>
                                doc.includes(`source=${sourceId}&`),
                            );
                            if (document) {
                                documentList.push({
                                    doc_url: document,
                                    doc_name: "Kotlin App Guide",
                                    doc_code: sourceCode,
                                });
                            }
                        }
                        if (
                            tracker?.document_urls &&
                            tracker?.document_urls?.["app_capi.ios"]
                        ) {
                            let document = tracker?.document_urls?.[
                                "app_capi.ios"
                            ].find((doc) =>
                                doc.includes(`source=${sourceId}&`),
                            );
                            if (document) {
                                documentList.push({
                                    doc_url: document,
                                    doc_name: "Swift App Guide",
                                    doc_code: sourceCode,
                                });
                            }
                        }
                        if (
                            tracker?.document_urls &&
                            tracker?.document_urls?.app_capi
                        ) {
                            let document =
                                tracker?.document_urls?.app_capi.find((doc) =>
                                    doc.includes(`source=${sourceId}&`),
                                );
                            if (document) {
                                if (
                                    documentList.find(
                                        (x) => x.doc_name === "App Capi Guide",
                                    ) === undefined
                                ) {
                                    documentList.push({
                                        doc_url: document,
                                        doc_name: "App Capi Guide",
                                        doc_code: sourceCode,
                                    });
                                }
                            }
                        }
                    } else if (sourceCode === "capi") {
                        if (
                            tracker?.document_urls &&
                            tracker?.document_urls?.implementation
                        ) {
                            let document =
                                tracker?.document_urls?.implementation.find(
                                    (doc) =>
                                        doc.includes(`source=${sourceId}&`),
                                );
                            if (document) {
                                documentList.push({
                                    doc_url: document,
                                    doc_name:
                                        language?.buttons
                                            ?.offline_events_api_document ??
                                        "Offline Events API Document",
                                    doc_code: sourceCode,
                                });
                            }
                        }
                    } else if (sourceCode === "js") {
                        if (
                            tracker?.document_urls &&
                            tracker?.document_urls?.transition
                        ) {
                            let document =
                                tracker?.document_urls?.transition.find((doc) =>
                                    doc.includes(`source=${sourceId}&`),
                                );
                            if (document) {
                                documentList.push({
                                    doc_url: document,
                                    doc_name:
                                        language?.buttons
                                            ?.frontend_modification_guide ??
                                        "GTM/Frontend Modification Guide",
                                    doc_code: sourceCode,
                                });
                            }
                        }
                    } else if (sourceCode === "redirect") {
                        if (
                            tracker?.document_urls &&
                            tracker?.document_urls["implementation.redirect"]
                        ) {
                            let document = tracker?.document_urls[
                                "implementation.redirect"
                            ].find((doc) =>
                                doc.includes(`source=${sourceId}&`),
                            );
                            if (document) {
                                documentList.push({
                                    doc_url: document,
                                    doc_name:
                                        language?.buttons?.redirect_guide ??
                                        "Link Event Source Guide",
                                    doc_code: sourceCode,
                                });
                            }
                        }
                    }
                });
            }
            setApiDocumentList(documentList);
        }
    }, [tracker]);

    const [trackerRowStatus, setTrackerRowStatus] = useState(false);

    useEffect(() => {
        if (
            tracker?.tracker?.sources?.length > 2 &&
            tracker?.tracker?.destinations?.length > 2
        ) {
            setTrackerRowStatus(true);
        }
    }, [tracker]);

    const getSourceIconHandler = (arr, id) => getSourceIcon(arr, id);

    const getDestinationIconHandler = (arr, id) => {
        if (arr) {
            let _newDestination = [...arr];
            if (
                _newDestination.find((x) => x.destination_type_id === id) !==
                undefined
            ) {
                let code = _newDestination.find(
                    (x) => x.destination_type_id === id,
                ).destination_type.code;
                return getDestinationIcon(code);
            }
        }
    };

    const [destinationModalOpen, setDestinationModalOpen] = useState(false);
    const [destinationModalItem, setDestinationModalItem] = useState({});
    const [destinationModalInitialTab, setDestinationModalInitialTab] =
        useState(null);

    const handleOpenSourceModal = (item, initialTab = null) => {
        setSourceModalOpen(true);
        setSourceModalItem(item);
        setSourceModalInitialTab(initialTab);
    };

    const sourceModalOnHide = () => {
        setSourceModalOpen(false);
        setSourceModalItem({});
        setSourceModalInitialTab(null);
    };

    const activeSourceModalItem =
        tracker?.tracker?.sources?.find(
            (item) => item.id === sourceModalItem?.id,
        ) || sourceModalItem;

    const handleOpenDestinationModal = (item, initialTab = null) => {
        setDestinationModalOpen(true);
        setDestinationModalItem(item);
        setDestinationModalInitialTab(initialTab);
    };

    const destinationModalOnHide = () => {
        setDestinationModalOpen(false);
        setDestinationModalItem({});
        setDestinationModalInitialTab(null);
    };

    const activeDestinationModalItem =
        tracker?.tracker?.destinations?.find(
            (item) => item.id === destinationModalItem?.id,
        ) || destinationModalItem;

    const openInNewTab = (url) => {
        window.open(url, "_blank", "noreferrer");
    };

    const openDocumentNewTab = (event, url) => {
        event.preventDefault();
        event.stopPropagation();
        openInNewTab(url);
        return false;
    };

    const renderSendInstructionsCard = () => {
        return (
            <DocumentCard
                title={
                    language?.tracker_detail?.send_instructions ??
                    "Send Instructions"
                }
            >
                <Typography
                    sx={{
                        fontFamily: "Nunito, sans-serif",
                        color: "text.secondary",
                        fontSize: 14,
                    }}
                >
                    {language?.tracker_detail?.send_instruction_text ??
                        "To complete the implementation process, you can send an instruction email to your developer so they can finish the SignalSight frontend code modification step."}
                </Typography>
                <Box
                    component="ul"
                    sx={{
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        mt: 3,
                    }}
                >
                    {tracker?.document_urls?.implementation ||
                    tracker?.document_urls?.transition ||
                    tracker?.document_urls?.app_capi ||
                    tracker?.document_urls?.app_capi?.android ||
                    tracker?.document_urls?.app_capi?.ios ? (
                        <Box
                            component="li"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                            }}
                        >
                            <StandartButton
                                variant={ButtonVariant.BLACK_OUTLINED}
                                onClick={handleShowMailModal}
                            >
                                {language?.buttons?.send_document ??
                                    "Send Document"}
                            </StandartButton>
                        </Box>
                    ) : (
                        <Box component="li">
                            <Box
                                className="mt-3"
                                sx={{ color: "red", fontSize: "18px" }}
                            >
                                {language?.tracker_detail
                                    ?.document_instructions ??
                                    "Document instructions is not available in this tracker."}
                            </Box>
                        </Box>
                    )}
                </Box>
            </DocumentCard>
        );
    };

    useEffect(() => {
        if (tracker) {
            if (
                tracker?.tracker?.sources.filter(
                    (x) =>
                        x?.source_type?.code === "js" ||
                        x?.source_type?.code === "redirect" ||
                        x?.source_type?.code === "capi" ||
                        x?.source_type?.code === "ioscapi" ||
                        x?.source_type?.code === "androidcapi",
                ).length > 0
            ) {
                setDocumentDetailStatus(true);
            } else {
                setDocumentDetailStatus(false);
            }
        }
    }, [tracker]);

    const getPlatformIcon = (platform) => {
        const handlers = [
            {
                predicate: () => platform === "android",
                handler: () => "/assets/images/androidcapi.png",
            },
            {
                predicate: () => platform === "ios",
                handler: () => "/assets/images/ioscapi.png",
            },
            {
                predicate: () => platform === "windows",
                handler: () => "/assets/images/windows.png",
            },
        ];
        return handlers.find(({ predicate }) => predicate())?.handler();
    };

    return (
        <PageContainer
            hasContent={Boolean(tracker?.tracker)}
            showBackButton={true}
            onBack={() => navigate("/trackers")}
            title={"Tracker Details"}
            subtitle={
                <InlineTrackerNameEdit
                    trackerId={params.id}
                    name={tracker?.tracker?.tracker_name}
                    loading={
                        (trackerStatus === "idle" ||
                            trackerStatus === "loading") &&
                        !tracker?.tracker?.tracker_name
                    }
                />
            }
            additionalButtons={
                <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    sx={{
                        width: { xs: "100%", md: "auto" },
                        gap: { xs: 1, sm: 2 },
                        marginLeft: { xs: 0, md: "auto" },
                        justifyContent: {
                            xs: "flex-start",
                            sm: "flex-end",
                        },
                        "& > *": {
                            flexShrink: 0,
                        },
                    }}
                >
                    <BusinessSelect fromRightNav={false} />
                    <Tooltip title="Event Mapping">
                        <Box>
                            <StandartButton
                                onClick={() =>
                                    navigate(`${routes.tracker_events}`)
                                }
                                color="primary"
                                variant={ButtonVariant.BLACK_OUTLINED}
                                iconButton
                            >
                                <AccountTreeOutlinedIcon />
                            </StandartButton>
                        </Box>
                    </Tooltip>
                    <TrackerNotes trackerId={params.id} />
                    <Tooltip title="Tracker Settings">
                        <Box>
                            <StandartButton
                                onClick={() =>
                                    navigate(
                                        `${routes.tracker_setting}/${params.id}`,
                                    )
                                }
                                color="primary"
                                variant={ButtonVariant.BLACK_OUTLINED}
                                iconButton
                            >
                                <Stack
                                    direction="row"
                                    gap={1}
                                    alignItems="center"
                                >
                                    <SettingsOutlinedIcon />
                                    <Box>
                                        {language?.tracker_detail
                                            ?.tracker_setting ?? "Settings"}
                                    </Box>
                                </Stack>
                            </StandartButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Tracker Reports">
                        <Box>
                            <StandartButton
                                onClick={() =>
                                    navigate(`/tracker-reports/${params.id}`)
                                }
                                color="primary"
                                variant={ButtonVariant.BLACK_OUTLINED}
                                id="tour-reports-btn"
                            >
                                <Stack
                                    direction="row"
                                    gap={1}
                                    alignItems="center"
                                >
                                    <AnalyticsOutlinedIcon />
                                    <Box>
                                        {language?.tracker_detail?.reports ??
                                            "Reports"}
                                    </Box>
                                </Stack>
                            </StandartButton>
                        </Box>
                    </Tooltip>
                </Stack>
            }
            loading={trackerStatus === "loading"}
            containerClassName="tracker-detail-area"
        >
            <div className="dashboard-area p-0 mt-4">
                <div
                    className={
                        trackerRowStatus
                            ? "dashboard-tree tracker-detail-tree logo-center"
                            : "tracker-detail-tree dashboard-tree"
                    }
                >
                    <div className="row mb-3">
                        <div className="col-sm-12 process-diagram-area">
                            <FlowDiagram
                                trackers={
                                    tracker?.tracker ? [tracker.tracker] : []
                                }
                                ungrouped
                                bare
                                columnWidth={380}
                                onAddSource={handleShowSourceModal}
                                onAddDestination={handleShowDestinationModal}
                                sourcesTitle={
                                    language?.home_page?.sources_title ??
                                    "Sources"
                                }
                                destinationsTitle={
                                    language?.home_page?.destinations_title ??
                                    "Destinations"
                                }
                                addSourceLabel={
                                    language?.buttons?.add_new_source ??
                                    "Add Source"
                                }
                                addDestinationLabel={
                                    language?.buttons?.add_new_destination ??
                                    "Add Destination"
                                }
                                renderSourceCard={(item) => (
                                    <Box
                                        onClick={() => {
                                            handleOpenSourceModal(item);
                                        }}
                                        sx={{ cursor: "pointer" }}
                                    >
                                        <CardContent
                                            style={{
                                                padding: "20px",
                                            }}
                                            className="d-flex items-center justify-start"
                                        >
                                            <div className="item-title-left-col">
                                                <Typography>
                                                    <div className="item-icon-area">
                                                        <LogoIcon
                                                            src={getSourceIcon(
                                                                tracker.tracker
                                                                    .sources,
                                                                item
                                                                    ?.source_type
                                                                    ?.id,
                                                            )}
                                                        />
                                                    </div>
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: 18,
                                                        fontWeight: "700",
                                                        fontFamily:
                                                            "Nunito, sans-serif",
                                                        color:
                                                            item?.status === 0
                                                                ? "red"
                                                                : "black",
                                                    }}
                                                >
                                                    {item?.source_type?.name}
                                                    {item?.status === 0 && (
                                                        <SourceErrorTooltip
                                                            placement="top"
                                                            style={{
                                                                marginLeft:
                                                                    "10px",
                                                            }}
                                                            title={
                                                                <React.Fragment>
                                                                    <Typography color="white">
                                                                        {language
                                                                            ?.tracker_detail
                                                                            ?.error ??
                                                                            "Error"}
                                                                    </Typography>
                                                                    <span>
                                                                        {language
                                                                            ?.tracker_detail
                                                                            ?.source_error_tooltip_message ??
                                                                            "Since the Access Token is expired, you must reconnect the source."}
                                                                    </span>
                                                                </React.Fragment>
                                                            }
                                                        >
                                                            <WarningIcon></WarningIcon>
                                                        </SourceErrorTooltip>
                                                    )}
                                                </Typography>
                                            </div>
                                            {[
                                                "capi",
                                                "js",
                                                "redirect",
                                                "androidcapi",
                                                "ioscapi",
                                            ].includes(
                                                item?.source_type?.code,
                                            ) === false
                                                ? getSourceDocumentLink(
                                                      item?.source_type?.code,
                                                  ) !== "" && (
                                                      <a
                                                          href="javascript:;"
                                                          onClick={(e) =>
                                                              openDocumentNewTab(
                                                                  e,
                                                                  getSourceDocumentLink(
                                                                      item
                                                                          ?.source_type
                                                                          ?.code,
                                                                  ),
                                                              )
                                                          }
                                                          className="document-view-link width-auto"
                                                          style={{
                                                              color: "#ed6c02",
                                                              marginLeft:
                                                                  "auto",
                                                              display:
                                                                  "inline-block",
                                                          }}
                                                      >
                                                          <MenuBookOutlinedIcon></MenuBookOutlinedIcon>
                                                      </a>
                                                  )
                                                : apiDocumentList &&
                                                  apiDocumentList.length >
                                                      0 && (
                                                      <>
                                                          {item?.source_type
                                                              ?.code === "js" &&
                                                              apiDocumentList.find(
                                                                  (x) =>
                                                                      x?.doc_code ===
                                                                      item
                                                                          ?.source_type
                                                                          ?.code,
                                                              )?.doc_url !==
                                                                  undefined && (
                                                                  <a
                                                                      href="javascript:;"
                                                                      onClick={(
                                                                          e,
                                                                      ) =>
                                                                          openDocumentNewTab(
                                                                              e,
                                                                              apiDocumentList.find(
                                                                                  (
                                                                                      x,
                                                                                  ) =>
                                                                                      x?.doc_code ===
                                                                                      item
                                                                                          ?.source_type
                                                                                          ?.code,
                                                                              )
                                                                                  ?.doc_url,
                                                                          )
                                                                      }
                                                                      className="document-view-link width-auto"
                                                                      style={{
                                                                          color: "#ed6c02",
                                                                          marginLeft:
                                                                              "auto",
                                                                          display:
                                                                              "inline-block",
                                                                      }}
                                                                  >
                                                                      <MenuBookOutlinedIcon></MenuBookOutlinedIcon>
                                                                  </a>
                                                              )}
                                                          {item?.source_type
                                                              ?.code ===
                                                              "redirect" &&
                                                              apiDocumentList.find(
                                                                  (x) =>
                                                                      x?.doc_code ===
                                                                      item
                                                                          ?.source_type
                                                                          ?.code,
                                                              )?.doc_url !==
                                                                  undefined && (
                                                                  <a
                                                                      href="javascript:;"
                                                                      onClick={(
                                                                          e,
                                                                      ) =>
                                                                          openDocumentNewTab(
                                                                              e,
                                                                              apiDocumentList.find(
                                                                                  (
                                                                                      x,
                                                                                  ) =>
                                                                                      x?.doc_code ===
                                                                                      item
                                                                                          ?.source_type
                                                                                          ?.code,
                                                                              )
                                                                                  ?.doc_url,
                                                                          )
                                                                      }
                                                                      className="document-view-link width-auto"
                                                                      style={{
                                                                          color: "#ed6c02",
                                                                          marginLeft:
                                                                              "auto",
                                                                          display:
                                                                              "inline-block",
                                                                      }}
                                                                  >
                                                                      <MenuBookOutlinedIcon></MenuBookOutlinedIcon>
                                                                  </a>
                                                              )}
                                                          {item?.source_type
                                                              ?.code ===
                                                              "capi" &&
                                                              apiDocumentList.find(
                                                                  (x) =>
                                                                      x?.doc_code ===
                                                                      item
                                                                          ?.source_type
                                                                          ?.code,
                                                              )?.doc_url !==
                                                                  undefined && (
                                                                  <a
                                                                      href="javascript:;"
                                                                      onClick={(
                                                                          e,
                                                                      ) =>
                                                                          openDocumentNewTab(
                                                                              e,
                                                                              apiDocumentList.find(
                                                                                  (
                                                                                      x,
                                                                                  ) =>
                                                                                      x?.doc_code ===
                                                                                      item
                                                                                          ?.source_type
                                                                                          ?.code,
                                                                              )
                                                                                  ?.doc_url,
                                                                          )
                                                                      }
                                                                      className="document-view-link width-auto"
                                                                      style={{
                                                                          color: "#ed6c02",
                                                                          marginLeft:
                                                                              "auto",
                                                                          display:
                                                                              "inline-block",
                                                                      }}
                                                                  >
                                                                      <MenuBookOutlinedIcon></MenuBookOutlinedIcon>
                                                                  </a>
                                                              )}
                                                          {item?.source_type
                                                              ?.code ===
                                                              "androidcapi" &&
                                                              apiDocumentList.find(
                                                                  (x) =>
                                                                      x?.doc_code ===
                                                                      item
                                                                          ?.source_type
                                                                          ?.code,
                                                              )?.doc_url !==
                                                                  undefined && (
                                                                  <a
                                                                      href="javascript:;"
                                                                      onClick={(
                                                                          e,
                                                                      ) =>
                                                                          openDocumentNewTab(
                                                                              e,
                                                                              apiDocumentList.find(
                                                                                  (
                                                                                      x,
                                                                                  ) =>
                                                                                      x?.doc_code ===
                                                                                      item
                                                                                          ?.source_type
                                                                                          ?.code,
                                                                              )
                                                                                  ?.doc_url,
                                                                          )
                                                                      }
                                                                      className="document-view-link width-auto"
                                                                      style={{
                                                                          color: "#ed6c02",
                                                                          marginLeft:
                                                                              "auto",
                                                                          display:
                                                                              "inline-block",
                                                                      }}
                                                                  >
                                                                      <MenuBookOutlinedIcon></MenuBookOutlinedIcon>
                                                                  </a>
                                                              )}
                                                          {item?.source_type
                                                              ?.code ===
                                                              "ioscapi" &&
                                                              apiDocumentList.find(
                                                                  (x) =>
                                                                      x?.doc_code ===
                                                                      item
                                                                          ?.source_type
                                                                          ?.code,
                                                              )?.doc_url !==
                                                                  undefined && (
                                                                  <a
                                                                      href="javascript:;"
                                                                      onClick={(
                                                                          e,
                                                                      ) =>
                                                                          openDocumentNewTab(
                                                                              e,
                                                                              apiDocumentList.find(
                                                                                  (
                                                                                      x,
                                                                                  ) =>
                                                                                      x?.doc_code ===
                                                                                      item
                                                                                          ?.source_type
                                                                                          ?.code,
                                                                              )
                                                                                  ?.doc_url,
                                                                          )
                                                                      }
                                                                      className="document-view-link width-auto"
                                                                      style={{
                                                                          color: "#ed6c02",
                                                                          marginLeft:
                                                                              "auto",
                                                                          display:
                                                                              "inline-block",
                                                                      }}
                                                                  >
                                                                      <MenuBookOutlinedIcon></MenuBookOutlinedIcon>
                                                                  </a>
                                                              )}
                                                      </>
                                                  )}
                                        </CardContent>
                                        <CardContent
                                            style={{
                                                padding: "20px",
                                                paddingTop: "0",
                                                flexWrap: "wrap",
                                            }}
                                            className="d-flex items-center justify-start"
                                        >
                                            {item?.allowed_domains !==
                                                undefined &&
                                            item?.source_type?.code !==
                                                "appsflyer" &&
                                            item?.source_type?.code !==
                                                "adjust" &&
                                            item?.allowed_domains.length > 0 ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            fontSize: "14px",
                                                            color: "black",
                                                            fontWeight: "500",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                display:
                                                                    "block",
                                                                fontSize:
                                                                    "12px",
                                                                color: "#ABABAB",
                                                                fontWeight:
                                                                    "400",
                                                            }}
                                                        >
                                                            {language
                                                                ?.tracker_detail
                                                                ?.domain ??
                                                                "Domain"}
                                                        </span>
                                                        <Stack
                                                            direction="row"
                                                            gap={1}
                                                            alignItems="center"
                                                        >
                                                            {
                                                                item
                                                                    ?.allowed_domains[0]
                                                                    ?.domain
                                                            }
                                                            {(item?.source_type
                                                                ?.code ===
                                                                "js" ||
                                                                item
                                                                    ?.source_type
                                                                    ?.code ===
                                                                    "capi") && (
                                                                <CopyIconButton
                                                                    value={
                                                                        item
                                                                            ?.allowed_domains[0]
                                                                            ?.domain
                                                                    }
                                                                    tooltipLabel="Copy Domain"
                                                                    stopPropagation
                                                                />
                                                            )}
                                                        </Stack>
                                                    </span>
                                                </>
                                            ) : (
                                                item?.source_type?.code !==
                                                    "appsflyer" &&
                                                item?.source_type?.code !==
                                                    "adjust" && (
                                                    <>
                                                        <span
                                                            style={{
                                                                display:
                                                                    "block",
                                                                width: "100%",
                                                                minWidth: 0,
                                                                fontSize:
                                                                    "14px",
                                                                color: "black",
                                                                fontWeight:
                                                                    "500",
                                                                overflowWrap:
                                                                    "anywhere",
                                                                wordBreak:
                                                                    "break-word",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    display:
                                                                        "block",
                                                                    fontSize:
                                                                        "12px",
                                                                    color: "#ABABAB",
                                                                    fontWeight:
                                                                        "400",
                                                                }}
                                                            >
                                                                {language
                                                                    ?.tracker_detail
                                                                    ?.name ??
                                                                    "Name"}
                                                            </span>
                                                            {item?.name}
                                                        </span>
                                                    </>
                                                )
                                            )}
                                            {(item?.source_type?.code ===
                                                "appsflyer" ||
                                                item?.source_type?.code ===
                                                    "adjust") && (
                                                <>
                                                    {item?.extras?.find(
                                                        (extra) =>
                                                            extra?.key ===
                                                            "app_id",
                                                    ) && (
                                                        <span
                                                            className="mb-2"
                                                            style={{
                                                                display:
                                                                    "block",
                                                                fontSize:
                                                                    "14px",
                                                                color: "black",
                                                                fontWeight:
                                                                    "500",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    display:
                                                                        "block",
                                                                    fontSize:
                                                                        "12px",
                                                                    color: "#ABABAB",
                                                                    fontWeight:
                                                                        "400",
                                                                }}
                                                            >
                                                                {"ID"}
                                                            </span>
                                                            {
                                                                item?.extras?.find(
                                                                    (extra) =>
                                                                        extra?.key ===
                                                                        "app_id",
                                                                )?.value
                                                            }
                                                        </span>
                                                    )}

                                                    {item?.extras?.find(
                                                        (extra) =>
                                                            extra?.key ===
                                                            "platform",
                                                    ) && (
                                                        <span
                                                            style={{
                                                                display:
                                                                    "block",
                                                                fontSize:
                                                                    "14px",
                                                                color: "black",
                                                                fontWeight:
                                                                    "500",
                                                                marginRight:
                                                                    "12px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    display:
                                                                        "block",
                                                                    fontSize:
                                                                        "12px",
                                                                    color: "#ABABAB",
                                                                    fontWeight:
                                                                        "400",
                                                                }}
                                                            >
                                                                {"Platform"}
                                                            </span>
                                                            <img
                                                                style={{
                                                                    width: "20px",
                                                                }}
                                                                src={getPlatformIcon(
                                                                    item?.extras?.find(
                                                                        (
                                                                            extra,
                                                                        ) =>
                                                                            extra?.key ===
                                                                            "platform",
                                                                    )?.value,
                                                                )}
                                                            />
                                                        </span>
                                                    )}
                                                    {item?.extras?.find(
                                                        (extra) =>
                                                            extra?.key ===
                                                            "marketplace_installed",
                                                    ) && (
                                                        <span
                                                            style={{
                                                                display:
                                                                    "block",
                                                                fontSize:
                                                                    "14px",
                                                                color: "black",
                                                                fontWeight:
                                                                    "500",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    display:
                                                                        "block",
                                                                    fontSize:
                                                                        "12px",
                                                                    color: "#ABABAB",
                                                                    fontWeight:
                                                                        "400",
                                                                }}
                                                            >
                                                                {
                                                                    "Integration Type"
                                                                }
                                                            </span>
                                                            {item?.extras?.find(
                                                                (extra) =>
                                                                    extra?.key ===
                                                                    "marketplace_installed",
                                                            )?.value === "0"
                                                                ? "API Integration"
                                                                : "Marketplace Integration"}
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </CardContent>
                                        {item?.status === 0 && (
                                            <CardContent
                                                style={{
                                                    paddingTop: 0,
                                                    borderTop:
                                                        "1px solid #E7E7E7",
                                                }}
                                                sx={{
                                                    pt: 0,
                                                    "&:last-child": {
                                                        pb: 2,
                                                    },
                                                }}
                                            >
                                                <Stack
                                                    direction={{
                                                        xs: "column",
                                                        sm: "row",
                                                    }}
                                                    spacing={1}
                                                    width="100%"
                                                    sx={{
                                                        mt: 2,
                                                    }}
                                                    justifyContent={{
                                                        xs: "stretch",
                                                        sm: "flex-end",
                                                    }}
                                                >
                                                    {getSourceTabs(
                                                        item?.source_type?.code,
                                                        "tracker",
                                                    ).includes("reconnect") && (
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                width: {
                                                                    xs: "100%",
                                                                    sm: "50%",
                                                                },
                                                                alignSelf: {
                                                                    xs: "stretch",
                                                                    sm: "auto",
                                                                },
                                                            }}
                                                            style={{
                                                                minWidth:
                                                                    "unset !important",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleOpenSourceModal(
                                                                    item,
                                                                    "reconnect",
                                                                );
                                                            }}
                                                        >
                                                            {language
                                                                ?.tracker_detail
                                                                ?.reconnect ??
                                                                "Reconnect"}
                                                        </Button>
                                                    )}
                                                    <Button
                                                        color="error"
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{
                                                            width: {
                                                                xs: "100%",
                                                                sm: "50%",
                                                            },
                                                            alignSelf: {
                                                                xs: "stretch",
                                                                sm: "auto",
                                                            },
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenSourceModal(
                                                                item,
                                                            );
                                                        }}
                                                    >
                                                        {language
                                                            ?.tracker_detail
                                                            ?.remove ??
                                                            "Remove"}
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        )}
                                    </Box>
                                )}
                                renderDestinationCard={(item) => {
                                    const index =
                                        tracker?.tracker?.destinations?.findIndex(
                                            (d) => d.id === item.id,
                                        );
                                    return (
                                        <Box
                                            onClick={() =>
                                                handleOpenDestinationModal(item)
                                            }
                                            sx={{ cursor: "pointer" }}
                                        >
                                            <CardContent
                                                style={{
                                                    padding: "20px",
                                                }}
                                                className="d-flex items-start justify-start"
                                            >
                                                <div
                                                    className="item-title-left-col"
                                                    style={{
                                                        flex: "1 1 auto",
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{ flexShrink: 0 }}
                                                    >
                                                        <div className="item-icon-area">
                                                            <LogoIcon
                                                                src={getDestinationIconHandler(
                                                                    tracker
                                                                        .tracker
                                                                        .destinations,
                                                                    item
                                                                        ?.destination_type
                                                                        ?.id,
                                                                )}
                                                            />
                                                        </div>
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 18,
                                                            fontWeight: "700",
                                                            fontFamily:
                                                                "Nunito, sans-serif",
                                                            color:
                                                                item?.status ===
                                                                0
                                                                    ? "red"
                                                                    : "black",
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            minWidth: 0,
                                                            whiteSpace:
                                                                "normal",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                minWidth: 0,
                                                                overflowWrap:
                                                                    "anywhere",
                                                            }}
                                                        >
                                                            {
                                                                item
                                                                    ?.destination_type
                                                                    ?.name
                                                            }
                                                        </span>
                                                        {item?.status === 0 && (
                                                            <DestinationErrorTooltip
                                                                placement="top"
                                                                style={{
                                                                    marginLeft:
                                                                        "10px",
                                                                    flexShrink: 0,
                                                                }}
                                                                title={
                                                                    <React.Fragment>
                                                                        <Typography color="white">
                                                                            {language
                                                                                ?.tracker_detail
                                                                                ?.error ??
                                                                                "Error"}
                                                                        </Typography>
                                                                        <span>
                                                                            {language
                                                                                ?.tracker_detail
                                                                                ?.destination_error_tooltip_message ??
                                                                                "Since the Access Token is expired, you must reconnect the destination."}
                                                                        </span>
                                                                    </React.Fragment>
                                                                }
                                                            >
                                                                <WarningIcon></WarningIcon>
                                                            </DestinationErrorTooltip>
                                                        )}
                                                    </Typography>
                                                </div>
                                                {item?.status !== 0 && (
                                                    <div
                                                        className="switch-area"
                                                        style={{
                                                            marginLeft: "auto",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        {toggleStatusLoadingIndex ===
                                                        index ? (
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    minWidth: 42,
                                                                    justifyContent:
                                                                        "center",
                                                                }}
                                                            >
                                                                <CircularProgress
                                                                    size={20}
                                                                    color="primary"
                                                                />
                                                            </Box>
                                                        ) : (
                                                            <Switch
                                                                className="switchStyle"
                                                                checked={
                                                                    trackersStatusList[
                                                                        index
                                                                    ]
                                                                }
                                                                disabled={
                                                                    toggleStatusLoadingIndex !==
                                                                    null
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    destinationModalOnHide();
                                                                    handleToggleStatus(
                                                                        trackersStatusList[
                                                                            index
                                                                        ],
                                                                        item?.id,
                                                                        index,
                                                                    );
                                                                }}
                                                                inputProps={{
                                                                    "aria-label":
                                                                        "controlled",
                                                                    "data-id":
                                                                        item?.id,
                                                                    "data-index":
                                                                        index,
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </CardContent>
                                            <CardContent
                                                style={{
                                                    padding: "20px",
                                                    paddingTop: "0",
                                                }}
                                                className="d-flex items-start justify-start"
                                            >
                                                <Stack
                                                    direction="row"
                                                    alignItems="flex-end"
                                                    justifyContent="space-between"
                                                    gap={1}
                                                    width="100%"
                                                >
                                                    {item?.destination_type
                                                        ?.code === "fbca" ? (
                                                        <Stack
                                                            spacing={1}
                                                            sx={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                            }}
                                                        >
                                                            {item?.name && (
                                                                <span
                                                                    style={{
                                                                        display:
                                                                            "block",
                                                                        width: "100%",
                                                                        minWidth: 0,
                                                                        fontSize:
                                                                            "14px",
                                                                        color: "black",
                                                                        fontWeight:
                                                                            "500",
                                                                        overflowWrap:
                                                                            "anywhere",
                                                                        wordBreak:
                                                                            "break-word",
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            display:
                                                                                "block",
                                                                            fontSize:
                                                                                "12px",
                                                                            color: "#ABABAB",
                                                                            fontWeight:
                                                                                "400",
                                                                        }}
                                                                    >
                                                                        {language
                                                                            ?.tracker_detail
                                                                            ?.name ??
                                                                            "Name"}
                                                                    </span>
                                                                    {item?.name}
                                                                </span>
                                                            )}
                                                            {item?.partner_reference_id && (
                                                                <span
                                                                    style={{
                                                                        display:
                                                                            "block",
                                                                        fontSize:
                                                                            "14px",
                                                                        color: "black",
                                                                        fontWeight:
                                                                            "500",
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            display:
                                                                                "block",
                                                                            fontSize:
                                                                                "12px",
                                                                            color: "#ABABAB",
                                                                            fontWeight:
                                                                                "400",
                                                                        }}
                                                                    >
                                                                        ID
                                                                    </span>
                                                                    {
                                                                        item?.partner_reference_id
                                                                    }
                                                                </span>
                                                            )}
                                                        </Stack>
                                                    ) : (
                                                        <span
                                                            style={{
                                                                display:
                                                                    "block",
                                                                flex: "1 1 auto",
                                                                minWidth: 0,
                                                                fontSize:
                                                                    "14px",
                                                                color: "black",
                                                                fontWeight:
                                                                    "500",
                                                                overflowWrap:
                                                                    "anywhere",
                                                                wordBreak:
                                                                    "break-word",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    display:
                                                                        "block",
                                                                    fontSize:
                                                                        "12px",
                                                                    color: "#ABABAB",
                                                                    fontWeight:
                                                                        "400",
                                                                }}
                                                            >
                                                                {language
                                                                    ?.tracker_detail
                                                                    ?.name ??
                                                                    "Name"}
                                                            </span>
                                                            {item?.name}
                                                        </span>
                                                    )}

                                                    <Box
                                                        sx={{
                                                            ml: "auto",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <CopyIconButton
                                                            value={
                                                                item?.partner_reference_id
                                                            }
                                                            tooltipLabel="Copy Pixel ID"
                                                            stopPropagation
                                                        />
                                                    </Box>
                                                </Stack>
                                            </CardContent>
                                            {item?.status === 0 && (
                                                <CardContent
                                                    style={{
                                                        paddingTop: 0,
                                                        borderTop:
                                                            "1px solid #E7E7E7",
                                                    }}
                                                    sx={{
                                                        pt: 0,
                                                        "&:last-child": {
                                                            pb: 2,
                                                        },
                                                    }}
                                                >
                                                    <Stack
                                                        direction={{
                                                            xs: "column",
                                                            sm: "row",
                                                        }}
                                                        spacing={1}
                                                        width="100%"
                                                        sx={{
                                                            mt: 2,
                                                        }}
                                                    >
                                                        {getDestinationTabs(
                                                            item
                                                                ?.destination_type
                                                                ?.code,
                                                        ).includes(
                                                            "reconnect",
                                                        ) && (
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                size="small"
                                                                sx={{
                                                                    width: {
                                                                        xs: "100%",
                                                                        sm: "auto",
                                                                    },
                                                                    flex: {
                                                                        sm: 1,
                                                                    },
                                                                    minWidth: {
                                                                        sm: 0,
                                                                    },
                                                                }}
                                                                style={{
                                                                    minWidth:
                                                                        "unset !important",
                                                                }}
                                                                onClick={(
                                                                    e,
                                                                ) => {
                                                                    e.stopPropagation();
                                                                    handleOpenDestinationModal(
                                                                        item,
                                                                        "reconnect",
                                                                    );
                                                                }}
                                                            >
                                                                {language
                                                                    ?.tracker_detail
                                                                    ?.reconnect ??
                                                                    "Reconnect"}
                                                            </Button>
                                                        )}
                                                        <Button
                                                            color="error"
                                                            variant="outlined"
                                                            size="small"
                                                            sx={{
                                                                width: {
                                                                    xs: "100%",
                                                                    sm: "auto",
                                                                },
                                                                flex: {
                                                                    sm: 1,
                                                                },
                                                                minWidth: {
                                                                    sm: 0,
                                                                },
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleOpenDestinationModal(
                                                                    item,
                                                                );
                                                            }}
                                                        >
                                                            {language
                                                                ?.tracker_detail
                                                                ?.remove ??
                                                                "Remove"}
                                                        </Button>
                                                    </Stack>
                                                </CardContent>
                                            )}
                                        </Box>
                                    );
                                }}
                                sourceTrailingContent={
                                    <Box position="relative">
                                        {existSourcesStatus === "loading" && (
                                            <div className="circle-loader">
                                                <ClipLoader
                                                    color={"#000"}
                                                    size={17}
                                                />
                                            </div>
                                        )}
                                        <StandartButton
                                            className="w-100 add-new-btn add-new-destination-btn"
                                            variant={
                                                ButtonVariant.BLACK_OUTLINED
                                            }
                                            onClick={handleShowSourceModal}
                                        >
                                            {language?.buttons
                                                ?.add_new_source ??
                                                "Add Source"}
                                        </StandartButton>
                                    </Box>
                                }
                                destinationTrailingContent={
                                    <Box position="relative">
                                        {isAddingDestination && (
                                            <div className="circle-loader">
                                                <ClipLoader
                                                    color={"#000"}
                                                    size={17}
                                                />
                                            </div>
                                        )}{" "}
                                        <StandartButton
                                            className="w-100 add-new-btn add-new-destination-btn"
                                            variant={
                                                ButtonVariant.BLACK_OUTLINED
                                            }
                                            onClick={handleShowDestinationModal}
                                            disabled={isAddingDestination}
                                        >
                                            {language?.buttons
                                                ?.add_new_destination ??
                                                "Add Destination"}
                                        </StandartButton>
                                    </Box>
                                }
                                emptySourceContent={
                                    <CardContent
                                        style={{
                                            padding: "20px",
                                        }}
                                        className="d-flex items-start justify-start flex-column"
                                    >
                                        <strong
                                            style={{
                                                fontSize: "24px",
                                                marginBottom: "10px",
                                                opacity: ".5",
                                            }}
                                        >
                                            {language?.tracker_detail
                                                ?.missing_source ??
                                                "Missing Source"}
                                        </strong>
                                        <p
                                            style={{
                                                marginBottom: "15px",
                                            }}
                                        >
                                            {language?.tracker_detail
                                                ?.missing_source_desc ??
                                                "You need at least one source to use a tracker."}
                                        </p>
                                        <Box position="relative">
                                            {existSourcesStatus ===
                                                "loading" && (
                                                <div className="circle-loader">
                                                    <ClipLoader
                                                        color={"#000"}
                                                        size={17}
                                                    />
                                                </div>
                                            )}
                                            <StandartButton
                                                className="w-100 add-new-btn add-new-destination-btn"
                                                variant={
                                                    ButtonVariant.BLACK_OUTLINED
                                                }
                                                onClick={handleShowSourceModal}
                                            >
                                                {language?.buttons
                                                    ?.add_new_source ??
                                                    "Add Source"}
                                            </StandartButton>
                                        </Box>
                                    </CardContent>
                                }
                                emptyDestinationContent={
                                    <CardContent
                                        style={{
                                            padding: "20px",
                                        }}
                                        className="d-flex items-start justify-start flex-column"
                                    >
                                        <strong
                                            style={{
                                                fontSize: "24px",
                                                marginBottom: "10px",
                                                opacity: ".5",
                                            }}
                                        >
                                            {language?.tracker_detail
                                                ?.missing_destination ??
                                                "Missing Destination"}
                                        </strong>
                                        <p
                                            style={{
                                                marginBottom: "15px",
                                            }}
                                        >
                                            {language?.tracker_detail
                                                ?.missing_destination_desc ??
                                                "You need at least one destination to use a tracker."}
                                        </p>
                                        <Box position="relative">
                                            {isAddingDestination && (
                                                <div className="circle-loader">
                                                    <ClipLoader
                                                        color={"#000"}
                                                        size={17}
                                                    />
                                                </div>
                                            )}{" "}
                                            <StandartButton
                                                className="w-100 add-new-btn add-new-destination-btn"
                                                variant={
                                                    ButtonVariant.BLACK_OUTLINED
                                                }
                                                onClick={
                                                    handleShowDestinationModal
                                                }
                                                disabled={isAddingDestination}
                                            >
                                                {language?.buttons
                                                    ?.add_new_destination ??
                                                    "Add Destination"}
                                            </StandartButton>
                                        </Box>
                                    </CardContent>
                                }
                            />
                            {tracker?.tracker?.event_mappings?.length > 0 && (
                                <div className="col-12">
                                    <EventMappingBox
                                        eventMappings={
                                            tracker.tracker.event_mappings
                                        }
                                        currentTrackerId={tracker.tracker.id}
                                        type="destination"
                                        onViewMappings={() => {
                                            // Navigate to event mappings page with focus on this tracker
                                            window.location.href = `/tracker/${tracker.tracker.id}/events`;
                                        }}
                                        language={language}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {tracker?.event_mappings?.length > 0 && (
                    <Box
                        sx={{
                            width: {
                                xs: "100%",
                            },
                        }}
                    >
                        <EventMappingBox
                            eventMappings={tracker.event_mappings}
                            currentTrackerId={tracker?.tracker?.id}
                            type="source"
                            onViewMappings={() => {
                                // Navigate to event mappings page with focus on this tracker
                                navigate("/tracker-events", {
                                    state: {
                                        eventMappings: tracker.event_mappings,
                                    },
                                });
                            }}
                            language={language}
                        />
                    </Box>
                )}
                {documentDetailStatus && (
                    <Box className="tracker-detail-document-area mt-4">
                        <Typography
                            sx={{
                                fontSize: "24px",
                                fontWeight: 700,
                                fontFamily: "Nunito, sans-serif",
                                marginBottom: "20px",
                            }}
                        >
                            {language?.tracker_detail?.what_next ??
                                "What's next?"}
                        </Typography>
                        <div className="row">
                            <div className="col-md-6 col-sm-12 mb-3">
                                <Stack spacing={2}>
                                    <DocumentCard
                                        icon={<LiveHelpOutlinedIcon />}
                                        title={
                                            language?.tracker_detail
                                                ?.guides_and_help ??
                                            "Guides & Help"
                                        }
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily:
                                                    "Nunito, sans-serif",
                                                color: "text.secondary",
                                                fontSize: 14,
                                            }}
                                        >
                                            {guideText}
                                        </Typography>
                                        <Box
                                            component="ul"
                                            sx={{
                                                listStyle: "none",
                                                margin: 0,
                                                padding: 0,
                                                mt: 3,
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1.5,
                                            }}
                                        >
                                            {tracker &&
                                                tracker.document_urls &&
                                                tracker.document_urls
                                                    .transition === "" &&
                                                tracker &&
                                                tracker.document_urls &&
                                                tracker.document_urls
                                                    .implementation === "" && (
                                                    <Box component="li">
                                                        <Box
                                                            className="mt-3"
                                                            sx={{
                                                                color: "red",
                                                                fontSize:
                                                                    "18px",
                                                            }}
                                                        >
                                                            {language
                                                                ?.tracker_detail
                                                                ?.implementation_guide ??
                                                                "Implementation guide is not available in this tracker."}
                                                        </Box>
                                                    </Box>
                                                )}
                                            {apiDocumentList.map((item) => (
                                                <Box
                                                    component="li"
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "flex-end",
                                                    }}
                                                >
                                                    <StandartButton
                                                        variant={
                                                            ButtonVariant.BLACK_OUTLINED
                                                        }
                                                        href={item.doc_url}
                                                        target="_blank"
                                                        className="tour-doc-btn"
                                                    >
                                                        {item.doc_name}
                                                    </StandartButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </DocumentCard>

                                    {renderSendInstructionsCard()}
                                </Stack>
                            </div>

                            <div className="col-md-6 col-sm-12">
                                <DocumentCard
                                    title={
                                        language?.tracker_detail
                                            ?.what_you_need_title ??
                                        "What you need to know to increase ad performance"
                                    }
                                >
                                    <Stack
                                        spacing={2}
                                        sx={{
                                            fontFamily: "Nunito, sans-serif",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily:
                                                    "Nunito, sans-serif",
                                                color: "text.secondary",
                                                fontSize: 14,
                                            }}
                                        >
                                            {language?.tracker_detail
                                                ?.what_you_need_description ??
                                                "By implementing the Conversions API, you can track three key metrics that help you monitor and optimize your ad performance. Understanding these metrics is essential for achieving the best possible results and reducing your cost per conversion."}
                                        </Typography>
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    mb: 0.5,
                                                }}
                                            >
                                                {language?.tracker_detail
                                                    ?.event_match_quality ??
                                                    "Event match quality"}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    color: "text.secondary",
                                                    fontSize: 14,
                                                }}
                                            >
                                                {language?.tracker_detail
                                                    ?.capi_event_match_quality_description ??
                                                    "Event Match Quality shows how accurately your customer information matches event instances in your Facebook account. Adding PII data should comply with your website’s privacy policy. Providing user parameters for each event can improve your EMQ score, leading to better performance and more conversions."}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    mb: 0.5,
                                                }}
                                            >
                                                {language?.tracker_detail
                                                    ?.rate_of_deduplication ??
                                                    "Rate of deduplication"}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    color: "text.secondary",
                                                    fontSize: 14,
                                                }}
                                            >
                                                {language?.tracker_detail
                                                    ?.capi_rate_of_deduplication_description ??
                                                    "Represents the percentage of events from the pixel and Conversions API that were deduplicated to ensure accurate counting."}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    mb: 0.5,
                                                }}
                                            >
                                                {language?.tracker_detail
                                                    ?.data_freshness ??
                                                    "Data freshness"}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    color: "text.secondary",
                                                    fontSize: 14,
                                                }}
                                            >
                                                {language?.tracker_detail
                                                    ?.capi_data_freshness_description ??
                                                    "Reveals the delay between when an event occurred and when we received it. This helps evaluate the likelihood that a person will take action after seeing your ad. By closely monitoring these metrics and following best practices, you can optimize ad performance and drive better results for your business."}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </DocumentCard>
                            </div>
                        </div>
                    </Box>
                )}
            </div>
            <SendInstructionsModal
                open={showMailModal}
                onClose={handleMailModalClose}
                tracker={tracker}
                language={language}
                onSendInstructions={handleSendInstructions}
            />

            {/* Generic Source Modal - handles all source types */}
            <SourceModal
                isOpen={sourceModalOpen}
                source={activeSourceModalItem}
                tracker={tracker}
                language={language}
                onClose={sourceModalOnHide}
                apiDocumentList={apiDocumentList}
                initialTab={sourceModalInitialTab}
            />

            {/* destination detail modal start  */}
            <DestinationModal
                isOpen={destinationModalOpen}
                destination={activeDestinationModalItem}
                tracker={tracker}
                language={language}
                onClose={destinationModalOnHide}
                initialTab={destinationModalInitialTab}
            />

            {/* destination delete dialog end  */}

            {/* exist destinations modal  */}

            <Modal
                className="new-ui-modal"
                show={
                    existDestinations &&
                    existDestinations.length > 0 &&
                    selecetableModalState
                }
                onHide={handleSelectDestModalClose}
            >
                <Modal.Header>
                    <Modal.Title>
                        {language?.buttons?.connect_destinations ??
                            "Connect Destinations"}
                    </Modal.Title>
                    <a href="javascript:;" onClick={handleSelectDestModalClose}>
                        <CloseIcon></CloseIcon>
                    </a>
                </Modal.Header>
                <Modal.Body>
                    <h2 className="pb-3">
                        {language?.tracker_detail
                            ?.select_existing_destinations ??
                            "Select one or more existing destinations"}
                    </h2>
                    {existDestinationsStatus === "idle" ||
                    existDestinationsStatus === "loading" ||
                    existDestinationsStatus === "failed" ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner
                                animation="border"
                                role="status"
                                variant="dark"
                                className="p-5 "
                            >
                                <span className="visually-hidden">
                                    {language?.trackers_page?.loading ??
                                        "Loading..."}
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <>
                            {existDestinations &&
                            existDestinations.length > 0 ? (
                                <Paper
                                    sx={{ width: "100%", overflow: "hidden" }}
                                    className="mui-modal-table-container"
                                >
                                    <TableContainer
                                        className="mui-modal-table"
                                        component={Paper}
                                        sx={{
                                            maxHeight: "50dvh",
                                            overflowY: "auto",
                                        }}
                                    >
                                        <Table
                                            stickyHeader
                                            size="sm"
                                            aria-label="a dense table"
                                            sx={{
                                                "& th": {
                                                    fontSize: "1rem",
                                                    color: "rgba(96, 96, 96)",
                                                },
                                            }}
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        {language
                                                            ?.add_destination_modal
                                                            ?.destination_name ??
                                                            "Destination Name"}
                                                    </TableCell>
                                                    <TableCell>
                                                        {language
                                                            ?.add_destination_modal
                                                            ?.destination_type ??
                                                            "Destination Type"}
                                                    </TableCell>
                                                    <TableCell>
                                                        Action
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <DestinationTableContainerOld
                                                    CheckHandlerDestination={
                                                        CheckHandlerDestination
                                                    }
                                                    existDestinations={
                                                        existDestinations
                                                    }
                                                    selectedDestination={
                                                        selectedDestination
                                                    }
                                                    selectedItems={
                                                        selectedItems
                                                    }
                                                    setSelectedItems={
                                                        setSelectedItems
                                                    }
                                                    availableDestinations={
                                                        availableDestinations
                                                    }
                                                />
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            ) : (
                                <div>
                                    {language?.tracker_detail
                                        ?.no_existing_destination ??
                                        "No existing Destination"}
                                </div>
                            )}
                        </>
                    )}
                    <div className="my-4">
                        <hr
                            className="or"
                            data-text={language?.tracker_detail?.or ?? "or"}
                        ></hr>
                        <p>
                            <strong>
                                {language?.tracker_detail
                                    ?.add_new_destination_msg ??
                                    "You can also create a new destination."}
                            </strong>
                        </p>
                        <Button
                            className="mt-3"
                            color="primary"
                            variant="outlined"
                            onClick={handleOpenCreateNewButton}
                        >
                            {language?.buttons?.create_new_destination ??
                                "Create New Destination"}
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer
                    className={
                        existDestinations && existDestinations.length > 0
                            ? "d-flex align-items-center justify-content-between"
                            : ""
                    }
                >
                    <Button
                        color="error"
                        variant="outlined"
                        className="btn-black-outlined"
                        onClick={handleSelectDestModalClose}
                    >
                        {language?.buttons?.close ?? "Close"}
                    </Button>
                    <Box position="relative">
                        {isAddExistDestinationModalLoading && (
                            <div className="circle-loader max-height-45">
                                <ClipLoader color={"#000"} size={17} />
                            </div>
                        )}
                        {existDestinations && existDestinations.length > 0 && (
                            <Button
                                disabled={
                                    selectedDestination.length === 0 ||
                                    isAddExistDestinationModalLoading
                                        ? true
                                        : false
                                }
                                onClick={handleSaveDestAdd}
                                className="tracker-save-btn modal-save-btn"
                                color="primary"
                                variant="contained"
                            >
                                {language?.buttons?.connect ?? "Connect"}
                            </Button>
                        )}
                    </Box>
                </Modal.Footer>
            </Modal>

            <Modal
                className="new-ui-modal"
                show={
                    existSources &&
                    existSources.length > 0 &&
                    selecetableModalStateSource
                }
                onHide={handleSelectSourceModalClose}
            >
                <Modal.Header>
                    <Modal.Title>
                        {language?.buttons?.connect_sources ??
                            "Connect Sources"}
                    </Modal.Title>
                    <a
                        href="javascript:;"
                        onClick={handleSelectSourceModalClose}
                    >
                        <CloseIcon></CloseIcon>
                    </a>
                </Modal.Header>
                <Modal.Body>
                    <h2 className="pb-3">
                        {language?.tracker_detail?.select_existing_sources ??
                            "Select one or more existing sources"}
                    </h2>
                    {existSourcesStatus === "idle" ||
                    existSourcesStatus === "loading" ||
                    existSourcesStatus === "failed" ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner
                                animation="border"
                                role="status"
                                variant="dark"
                                className="p-5 "
                            >
                                <span className="visually-hidden">
                                    {language?.trackers_page?.loading ??
                                        "Loading..."}
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <div className="row">
                            {existSources && existSources.length > 0 ? (
                                <div className="col-12 px-3">
                                    <SourceTableContainerOld
                                        selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems}
                                        Allsources={existSources}
                                        getAllSourcesReduxProps={
                                            getExistSourcesRedux
                                        }
                                        getSourceIcon={getSourceIconHandler}
                                    />
                                </div>
                            ) : (
                                <div className="col-12 px-3">
                                    {language?.tracker_detail
                                        ?.no_existing_source ??
                                        "No existing Source"}
                                </div>
                            )}
                        </div>
                    )}
                    <div className="my-4">
                        <hr
                            className="or"
                            data-text={language?.tracker_detail?.or ?? "or"}
                        ></hr>
                        <p>
                            <strong>
                                {language?.tracker_detail?.add_new_source_msg ??
                                    "You can also create a new source."}
                            </strong>
                        </p>
                        <Button
                            className="mt-3"
                            color="primary"
                            variant="outlined"
                            onClick={handleOpenCreateNewButtonSource}
                        >
                            {language?.buttons?.create_new_source ??
                                "Create New Source"}
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer
                    className={
                        existSources && existSources.length > 0
                            ? "d-flex align-items-center justify-content-between"
                            : ""
                    }
                >
                    <Button
                        color="error"
                        variant="outlined"
                        className="btn-black-outlined"
                        onClick={handleSelectSourceModalClose}
                    >
                        {language?.buttons?.close ?? "Close"}
                    </Button>
                    <Box position="relative">
                        {isAddExistSourceModalLoading && (
                            <div className="circle-loader max-height-45">
                                <ClipLoader color={"#000"} size={17} />
                            </div>
                        )}
                        {existSources && existSources.length > 0 && (
                            <Button
                                disabled={
                                    Object.keys(selectedItems).length === 0 ||
                                    isAddExistSourceModalLoading
                                        ? true
                                        : false
                                }
                                onClick={handleSaveSourceAdd}
                                className="tracker-save-btn modal-save-btn"
                                color="primary"
                                variant="contained"
                            >
                                {language?.buttons?.connect ?? "Connect"}
                            </Button>
                        )}
                    </Box>
                </Modal.Footer>
            </Modal>
        </PageContainer>
    );
};

export default SingleTracker;
